import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { ProductCard } from "@/components/ProductCard";

const AlertForm = ({ ids }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/price-alerts", { email, product_ids: ids, origin_url: window.location.origin });
      toast.success(`Avvisi attivati per ${data.subscribed} prodotti`);
    } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="border border-[#0F0F0F] bg-white p-5 flex flex-col md:flex-row md:items-center gap-4" data-testid="price-alert-form">
      <BellRing className="text-[#FF3333] shrink-0" strokeWidth={1.5} />
      <div className="flex-1">
        <p className="font-medium">Avvisami quando il prezzo scende</p>
        <p className="text-sm text-[#555]">Ti scriviamo solo se un prodotto della tua lista costa meno di adesso.</p>
      </div>
      <input data-testid="price-alert-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="La tua email" className="field md:w-72" />
      <button data-testid="price-alert-submit" disabled={busy} className="btn-primary h-11 px-5 text-sm">Attiva avvisi</button>
    </form>
  );
};

export default function Wishlist() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    if (!ids.length) return setProducts([]);
    api.get("/products-by-ids", { params: { ids: ids.join(",") } }).then((r) => setProducts(r.data));
  }, [ids]);

  return (
    <main className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 space-y-8" data-testid="wishlist-page">
      <div>
        <span className="tag text-[#555]">Salvati da te</span>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-1">Lista desideri</h1>
      </div>
      {products.length === 0 ? (
        <p className="text-[#555]" data-testid="wishlist-empty">
          Nessun prodotto salvato. Tocca il cuore su un'offerta per aggiungerla. <Link to="/" className="underline hover:text-[#FF3333]">Vai alle offerte</Link>
        </p>
      ) : (
        <>
          <AlertForm ids={products.map((p) => p.id)} />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
          </div>
        </>
      )}
    </main>
  );
}

export function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  useEffect(() => { api.delete(`/price-alerts/${token}`).then(() => setState("ok")).catch(() => setState("error")); }, [token]);
  return (
    <main className="max-w-xl mx-auto px-5 py-20" data-testid="unsubscribe-page">
      <h1 className="font-display font-black text-4xl tracking-tight" data-testid="unsubscribe-status">
        {state === "loading" ? "Un momento..." : state === "ok" ? "Iscrizione annullata" : "Link non valido o già usato"}
      </h1>
      {state === "ok" && <p className="mt-4 text-[#555]">Non riceverai più avvisi sui prezzi.</p>}
    </main>
  );
}
